/*
Prakash  26/10/2022 2701352898 Added classes for Text-Fields,Buttons and did prettier code.
Prakash 10/31/2022 2701352898 Added class for multi select drop down alignment issue.
Saikrishna 11/03/2022 3031450488 Done required changes for run report popup and fixed dynamic fields rendering issue
Sai Krishna 11/07/2022 3031450488 Added all fields in run and additional fields step and prepopulated dynamic fields in 5th step
Sai Krishna 11/08/2022 3031450488 rearranged fields and done multiple changes required and added multi complete component for notify errors and completion fields
Gummala Prakash 11/08/2022 3031450488 Added classes and fixed alignments for textfields.
Sai Krishna 11/08/2022 3031450488 Fixed prepopulation bugs and UI bugs
saikrishna 11/09/2022 3031450488 Validations and payload bugs and other field prepop bugs
akhila 11/10/2022 3031450488 removed Generate Report Output dropdown and renamed report format to Report Output Format
Prakash Gummala 11/10/2022  3031450488 Fixed TextFields Alignments.
Sohel 11/11/2022 3031450488 Filter method Added validation and fixed page break issue
saikrishna 11/11/2022 3031450488 Conditionally added seperator and report output fields
Ashraf 11/11/2022 3031450488 Conditionally render of action field
Sohel 11/11/2022 3031450488 Added Field Validation
Sohel 11/11/2022 3031450488 Added Separator Field Validation
Ashraf 11/11/2022 3031450488 fixed empty div render
Sohel 11/12/2022 3031450488 fixed report format prepopulate issue.
Rajesh 11/15/2022 3031450488 added props to condtionally render buttons.
Saikrishna 11/14/2022 3225733165 Fixed WQ string adding at start of work queue name
akhila 11/14/2022 3225733165 fixed button cancel to reset.
Prakash Gummala 11/14/2022 3031450488 Text Field Alignments for tab and Laptop-L Resolutions.
Saikrishna 11/15/2022 3031450488 Fixed report master prepop up
Ashraf 11/24/2022 3031450488 passing props to dynamic fields
Saikrishna 11/08/2022 2701375033 Run report popup changes after new report changes.
akhila 12/04/2022 2701375033 fixed starDate and endDate payload issues
Dilip 12/05/2022  2701375033 Removed unecesarry console.log statements
Saikrishna 12/07/2022 3075234474 Added notify email fields according to required changes.
Saikrishna 12/07/2022 3075234474 Added workqueue fields to run popup.
akhila 12/23/2022 3075234474 changed showDashboard  label
Raghu 12/28/2022 3075234474 removed notify errors
dilip 01/31/2023 3075234474 Show WOrk Queue List option changes
Akhila 02/10/2023 3075234474 implemented autoComplete field for existing show work queue lst and filter select field
Suresh Peddavoora  02/13/2023 2701375033 Fixed Textfields Variant
Prakash 02/13/2023 2701375033 Added New UI Style-classes for fields and buttons.
Sohel 02/13/2022 2692790263 roles dropdown issue
Akhila 02/10/2023 3075234474 implemented autoComplete field for existing show work queue lst and filter select field
Prakash 02/14/2023 3075234474 Implemented New UI Changes for Autocomplete Component.
Prakash 02/16/2023 2698964415 Fixed UI-Bug.
Prakash 02/16/2023 3075234474 Fixed Autocomplete dropdown alignments issue.
Akhila 03/03/2023 3075234474 multi email validation issue fixed
Akhila 03/03/2023 3075234474 bug fixed valid email
suresh peddavoora 03/08/2023 3075234474 error meessage alignment fixes
Ravi 03/25/2023 3075234474 Added GuiAutoComplete textField
Ravi 03/31/2023 3075234474 fixed value reset issue conditionally
 Prakash 20/04/2023 3075234474 fixed alignments issue in tab view
 Ravi 04/25/2023 3075234474 Added popup in dynamic field name
 Ravi 04/25/2023 3075234474 Removed useState isloadings
 Ravi 04/25/2023 3075234474 fixed prepopulate issue
 Prakash 28/04/2023 3075234474 remove unwanted padding
 Ravi 04/28/2023 3075234474 fixed prepopulate issue dynamic field name
Sohel 04/05/2022 3075234474 FIxed Filter Method Validation issue
 Ravi 05/12/2022 3075234474 fixed action field render issue
Akhila 05/16/2023 3075234474 modfied in condtion for field seprator and report output format
Ravi 05/17/2022 3075234474  Rename separator as Field Seperator
Akhila 06/07/2023 3075234474 Added code and description
Sohel 06/08/2023 3075234474 Added Between and Not Between condition For Account By status
Sohel 06/09/2023 3075154998 Added between and not Between in Filter Methods
Sohel 06/09/2023 3075234474 Payload Changes
Sohel 06/09/2023 3075154998 Values Field Changes
Ravi 06/14/2023 3075154998 fixed action reset issue
Akhila 06/15/2023 3075154998 added report path field
Akhila 06/16/2023 3075154998 modified report folder path field
Akhila 06/19/2023 3075154998 bug fixed prepopulation issue in report folder path
Akhila 06/19/2023 3075154998 filter method field by list date changes field TODAY or T
Ravi 06/15/2023 3075154998 removed by default initial value folder path and output file name
Akhila 30/06/2023 3075154998 condtionaly label name change for folder path and file name
Ravi 07/17/2023 3075154998 fixed prepopulate issue in filed Seperator
Ravi 07/18/2023 3075154998 show work Queue Filter field Conditionally
Sohel 10/16/2023 2698811066 Fixed Date Format issue
*/
import {
  FormControl,
  Button,
  TextField,
  makeStyles,
  FormHelperText,
  InputAdornment,
} from '@material-ui/core';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import React, {useEffect, useState, useContext, useRef} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {
  postRunAReport,
  reportMasterUserName,
  reportMasterRoleName,
  getFieldCode,
  getActions,
  postFieldCode,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import {useDispatch, useSelector} from 'react-redux';
import {FILE_TYPE, FIELD_SEPERATOR, DISPOSITION_CODE} from '../../../../constants/Lookup';
import GetAccessMethodFields from './GetAccessMethodFields';
import PageLoader from '../../../../components/PageLoader';
DISPOSITION_CODE;
import SearchRuleGroup from '../../BRE/FormulaRuleGroup/SearchRuleGroup';
import {ArrowBack} from '@material-ui/icons';
import * as yup from 'yup';
import {fetchFilter} from '../../../../redux/reducers/ReportMaster';
import {getDropDownData} from '../../../../redux/reducers/BRE/AddRecordFormat';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import {REPORTING_EXPORT} from '../../../../constants/ReusableRoleAccess';
import AddFileName from '../../Reports/AddReport/StepperComponents/AddFileName';
import DialogBox from '../../../../components/DialogBox';
import BreadCrums from '../../../../util/BreadCrum';
import {fetchUserDefinedFields} from '../../../../redux/reducers/EventTactics/EventTactics';
import ReportFolderPath from '../../Reports/AddReport/StepperComponents/ReportFolderPath';

const useStyles = makeStyles((theme) => ({
  goBackBtn: {
    padding: '6px 12px',
    color: '#320469',
    marginBottom: '10px',
  },
  conditionalFields: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  },
}));

const RunaReportMaster = ({reportDialogData, setSubmit, nightJobRun}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const dispatch = useDispatch();
  const [fieldSubmitted, setSubmitted] = useState(false);
  const [folderPath, setFolderPath] = useState(false);
  const componentClasses = useStyles();
  const displayHeaderData = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const OutTypeoptions = [
    {key: 'Text', value: 'Text'},
    {key: 'CSV', value: 'CSV'},
    {key: 'Excel', value: 'Excel'},
  ];
  const {
    isLoading,
    dropDownData,
    clientCodeData,
    accessMethodRunListData,
    promptData,
    runReportData,
    fieldCodeData,
    actionData,
  } = useSelector(({addReportMaster}) => addReportMaster);
  const {roleData} = useSelector(({role}) => role);
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE;
  const formDataRef = useRef();
  const resetPromptDataRef = useRef(false);
  const {getfilterData} = useSelector(({reportMaster}) => reportMaster);
  const {dropDownDataReportFormat} = useSelector(({addRecordFormat}) => ({
    dropDownDataReportFormat: addRecordFormat?.dropDownData,
  }));
  const getObjects = (option, typeCode) => {
    const options =
      dropDownDataReportFormat && dropDownDataReportFormat[typeCode] ?
        dropDownDataReportFormat[typeCode] :
        [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.valueCode === option.toString() || item.value === option) {
          label = item;
        }
      });
    return label;
  };

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.fieldCode === option || item.key === option || item.value === option) {
          label = item;
        }
      });
    return label;
  };

  const {additionalInfoData} = useSelector(({reportMaster}) => reportMaster);
  const [showRuleGroupSearch, setShowRuleGroupSearch] = useState(false);
  const initialVal = {
    generateReportOutput: reportDialogData?.genrateReportOutput ?
      reportDialogData?.genrateReportOutput :
      'Y',
    outputType: '',
    ShowOnlyTheReportTotals: 'N',
    RepeatFieldsForMultRecords: 'N',
    DateStampTheReportRun: 'No',
    DateForStampingDebtor: '',
    WindowToStamp: '',
    FieldToStamp: '',
    runFor: reportDialogData?.accessMethod || '',
    accessMethod: reportDialogData?.accessMethod ?
      getObject(reportDialogData?.accessMethod, fieldCodeData) :
      '',
    action: reportDialogData?.action ? reportDialogData?.action : '',
    displayHeader: reportDialogData?.displayHeader ?
      getObject(reportDialogData?.displayHeader, displayHeaderData) :
      '',
    notifyCompletion:
      reportDialogData?.notifyCompletionEmails?.length > 0 &&
      typeof reportDialogData?.notifyCompletionEmails === 'object' ?
        reportDialogData?.notifyCompletionEmails?.join(',') :
        '',
    notifyError:
      reportDialogData?.notifyErrorEmails?.length > 0 &&
      typeof reportDialogData?.notifyErrorEmails === 'object' ?
        reportDialogData?.notifyErrorEmails?.join(',') :
        '',
    reportFormat:
      // reportDialogData?.fixedLength === "Y"
      //   ? getObjects("Text", FILE_TYPE, dropDownDataReportFormat)
      reportDialogData?.reportFormat ?
        getObjects(reportDialogData?.reportFormat, FILE_TYPE, dropDownDataReportFormat) :
        getObjects('CSV', FILE_TYPE, dropDownDataReportFormat),
    fieldSeparator: reportDialogData?.fieldSeparator ?
      getObjects(reportDialogData?.fieldSeparator, FIELD_SEPERATOR, dropDownDataReportFormat) :
      {valueCode: 'comma', value: ','},
    fixedLength: reportDialogData?.fixedLength,
    outputFileName: getfilterData?.reportOutputFileName ? getfilterData?.reportOutputFileName : '',
    reportpath: getfilterData?.reportfolderPath ? getfilterData?.reportfolderPath : '',
  };
  const [initialValue, setInitialValue] = useState(initialVal);
  const {userDefinedWindowData, userDefinedFieldsData} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );

  useEffect(() => {
    setTimeout(() => {
      setData(getfilterData);
    }, 500);
  }, [getfilterData]);

  useEffect(() => {
    dispatch(reportMasterUserName());
    dispatch(reportMasterRoleName());
  }, []);
  useEffect(() => {
    if (reportDialogData?.reportId) {
      dispatch(fetchFilter(reportDialogData?.reportId));
    }
    dispatch(getDropDownData());
  }, [reportDialogData?.reportId]);
  useEffect(() => {
    let newInitialValues = {
      ...initialValue,
    };
    if (getCurrentAccessMethodFields()?.length > 0) {
      getCurrentAccessMethodFields().forEach((field) => {
        const name = field?.paramName;
        if (
          field.paramType === 'disposition' ||
          field.paramType === 'client' ||
          field.paramType === 'collector'
        ) {
          newInitialValues[name] = [];
        } else {
          newInitialValues[name] = '';
        }
      });
    }
    if (
      Object.keys(runReportData)?.length > 0 &&
      Object.keys(dropDownData).length > 0 &&
      accessMethodRunListData?.length > 0 &&
      runReportData?.accessMethodRequest?.accessMethod
    ) {
      newInitialValues = {...initialValue, ...runReportData};
      if (runReportData?.outputType && runReportData?.outputType.length > 0) {
        newInitialValues['outputType'] = OutTypeoptions.filter(
          (opt) => opt.value === runReportData?.outputType,
        )[0];
      }

      if (runReportData?.accessMethodRequest?.value?.length > 0) {
        if (getCurrentAccessMethodFields()?.length > 0) {
          getCurrentAccessMethodFields()?.forEach((field) => {
            const name = field['paramName'];
            if (field.paramType === 'disposition') {
              newInitialValues[name] =
                getOptions(DISPOSITION_CODE).length > 0 &&
                getOptions(DISPOSITION_CODE)
                  .map((code) => {
                    if (runReportData['accessMethodRequest']['value']?.includes(code.valueCode)) {
                      return code;
                    }
                    return null;
                  })
                  .filter((val) => Boolean(val));
            } else if (field.paramType === 'client') {
              newInitialValues[name] =
                clientCodeData.length > 0 &&
                clientCodeData
                  .map((code) => {
                    if (runReportData['accessMethodRequest']['value']?.includes(code.clientCode)) {
                      return code;
                    }
                    return null;
                  })
                  .filter((val) => Boolean(val));
            } else if (field.paramType === 'collector') {
              newInitialValues[name] = runReportData['accessMethodRequest']['value'];
            }
          });
        }
      }
    }
    (newInitialValues['accessMethod'] = reportDialogData?.accessMethod ?
      getObject(reportDialogData?.accessMethod, fieldCodeData) :
      ''),
    (newInitialValues['outputFileName'] = getfilterData?.reportOutputFileName ?
      getfilterData?.reportOutputFileName :
      ''),
    (newInitialValues['reportpath'] = getfilterData?.reportfolderPath ?
      getfilterData?.reportfolderPath :
      ''),
    setInitialValue(newInitialValues);
  }, [runReportData, dropDownData, clientCodeData, accessMethodRunListData, getfilterData]);

  function getCurrentAccessMethodFields() {
    if (
      Object.keys(runReportData)?.length > 0 &&
      runReportData?.accessMethodRequest?.accessMethod
    ) {
      return (
        accessMethodRunListData?.length > 0 &&
        accessMethodRunListData.filter(
          (data) => data.valueCode === runReportData?.accessMethodRequest?.accessMethod,
        )[0]?.json
      );
    } else {
      return (
        accessMethodRunListData?.length > 0 &&
        accessMethodRunListData.filter(
          (data) => data.valueCode === reportDialogData?.accessMethod,
        )[0]?.json
      );
    }
  }
  function getOptions(typeCode) {
    let label = [];
    label =
      dropDownDataReportFormat && dropDownDataReportFormat[typeCode] ?
        dropDownDataReportFormat[typeCode] :
        [];

    return label;
  }

  useEffect(() => {
    if (additionalInfoData?.accessMethod) {
      dispatch(
        postFieldCode({
          fieldCode: additionalInfoData?.accessMethod,
          options: additionalInfoData?.action,
        }),
      );
      // setFieldCodeValue({ fieldCode: additionalInfoData?.accessMethod })
    }
  }, [additionalInfoData]);

  function getOptionsRecordFormatDropDown(typeCode) {
    let label = [];
    label =
      dropDownDataReportFormat && dropDownDataReportFormat[typeCode] ?
        dropDownDataReportFormat[typeCode] :
        [];

    return label;
  }
  const [fieldCodeValue, setFieldCodeValue] = useState({});
  const handleClose = () => {
    setOpen(false);
    setFolderPath(false);
  };
  useEffect(() => {
    (fieldCodeValue?.fieldCode || reportDialogData?.accessMethod) &&
      dispatch(
        getActions(
          fieldCodeValue?.fieldCode ? fieldCodeValue?.fieldCode : reportDialogData?.accessMethod,
        ),
      );
  }, [fieldCodeValue?.fieldCode, reportDialogData?.accessMethod]);
  const getValue = (values) => {
    const a = values?.split(' ')?.join('');
    const dateValue = values?.length > 1 ? values?.slice(0, 5) :'';
    if (dateValue?.toUpperCase() === 'TODAY') {
      return a?.replace(dateValue, 'cast(now()as date)');
    } else if (values?.charAt(0)?.toUpperCase() === 'T') {
      return a?.replace(values?.charAt(0), 'cast(now()as date)');
    } else {
      return values;
    }
  };
  const getArrayData = (selectedAccessMethod, data) => {
    if (selectedAccessMethod === 'DBCOLLECTOR') {
      return data?.collectors && data?.collectors.length > 0 ?
        data.collectors.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSDISP') {
      return data?.disposition && data?.disposition.length > 0 ?
        data.disposition.map((i) => {
          return i.valueCode;
        }) :
        [];
    } else if (selectedAccessMethod === 'DBCLNT') {
      return data?.client && data?.client.length > 0 ?
        data.client.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSSTAT') {
      return data?.phase && data?.phase.length > 0 ? data.phase.map((i) => i?.valueCode) : [];
    } else if (selectedAccessMethod === 'DBUDWFIELDS') {
      return data?.values && data?.values.length > 0 ?
        data.values.map((i) => {
          if (data?.fieldsName?.fieldType?.toLowerCase() === 'date') {
            return getValue(i);
          } else {
            return i;
          }
        }) :
        [];
    } else {
      return [];
    }
  };

  const onSubmit = (data) => {
    const selectedAccessMethod = data?.accessMethod?.fieldCode;
    const payload = {
      accessMethodRequest: {
        accessMethod: data?.accessMethod?.fieldCode ? data?.accessMethod?.fieldCode : '',
        endDate:
            data?.action === '>' ?
              data?.Date ? // ? getFormattedDate(data?.Date)
                getValue(data?.Date) :
                data?.lastDate :
              data?.lastDate ? // ? getFormattedDate(data?.lastDate)
                getValue(data?.lastDate) :
                '',
        action: data?.action ? data?.action : '',
        startDate:
            data?.action === '<' ?
              data?.Date ? // ? getFormattedDate(data?.Date)
                getValue(data?.Date) :
                data?.startDate :
              data?.startDate ? // ? getFormattedDate(data?.startDate)
                getValue(data?.startDate) :
                '',
        value: ['Is Blank', 'Is Not Blank']?.includes(data?.action) ?
          [] :
          getArrayData(selectedAccessMethod, data),
        repositoryName: data?.repoitoryName?.repositoryName ? data?.repoitoryName?.repositoryName : '',
        fieldName: data?.fieldsName ? data?.fieldsName?.fieldName : '',
        fromValue:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
            ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
            data?.fromValues ?
              data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
                getValue(data?.fromValues) :
                data?.fromValues :
              '',
        toValue:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
            ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
            data?.toValues ?
              data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
                getValue(data?.toValues) :
                data?.toValues :
              '',
      },
      genrateReportOutput: data.generateReportOutput,
      // listAccessRoles: '',
      reportType: 'REPORT',
      outputType: data?.outputType?.value ? data?.outputType?.value : '',
      reportId: reportDialogData.reportId,
      displayHeader: data?.displayHeader ? data?.displayHeader?.key : '',
      fieldSeparator: data?.fieldSeparator?.value ? data?.fieldSeparator?.value : '',
      notifyCompletionEmails: data?.notifyCompletion ? data?.notifyCompletion.split(',') : [],
      notifyErrorEmails: data?.notifyError ? data?.notifyError.split(',') : [],
      reportFormat: data?.reportFormat?.value ? data?.reportFormat?.value : '',
      reportOutputFileName: data?.outputFileName ? data?.outputFileName : '',
      reportfolderPath: data?.reportpath ? data?.reportpath : '',
    };
    dispatch(postRunAReport(payload));
  };

  const validationSchema = yup.object().shape({
    notifyCompletion: yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length > 0) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    notifyError: yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length > 0) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    accessMethod: yup.mixed().test('accessMethod', 'Filter Method is required', (value) => {
      if (!value?.fieldCode) {
        return false;
      } else {
        return true;
      }
    }),
    displayHeader: yup.mixed().test('displayHeader', 'Display Header is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    reportFormat: yup.mixed().test('reportFormat', 'Report Output Format is required', (value) => {
      if (!value?.valueCode) {
        return false;
      } else {
        return true;
      }
    }),
    fieldSeparator: yup
      .mixed()
      .test('fieldSeparator', 'Field Separator is required', (value, ctx) => {
        if (
          !value?.value &&
          // ctx.parent.reportFormat?.valueCode !== "E" &&
          reportDialogData?.fixedLength === 'N'
        ) {
          return false;
        } else {
          return true;
        }
      }),
    client:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBCLNT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.array().test('client', 'Client is required', (val) => {
        if (val?.length > 0) {
          return true;
        } else {
          return false;
        }
      }),
    disposition:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DSDISP' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.array().test('dispo', 'Status is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    phase:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DSSTAT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.array().test('phase', 'Phase is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    collectors:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBCOLLECTOR' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.array().test('collector', 'Collector is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    Date:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['<', '>'].includes(formDataRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      // yup.date().typeError().nullable().required("Date is required"),
      yup?.mixed().test('Date', 'Values is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    startDate:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formDataRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      // yup.date().typeError().nullable().required("Start date is required"),
      yup.mixed().test('startDate', 'From Values is required', (val, exi) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    lastDate:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formDataRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      // yup
      //   .date()
      //   .typeError()
      //   .nullable()
      //   .required("End date is required")
      //   .min(yup.ref("startDate"), "End date should be greater than start date"),
      yup.mixed().test('lastDate', 'To Values is required', (val) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    repoitoryName:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.mixed().required('Repository Name is required').nullable(),
    fieldsName:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.mixed().required('Field Name is required').nullable(),
    toValues:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      ['BETWEEN', 'NOT BETWEEN']?.includes(formDataRef?.current?.values?.action) ?
        yup.mixed().test('toValues', 'To Values is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    values:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      !['Is Blank', 'Is Not Blank', 'NOT BETWEEN', 'BETWEEN']?.includes(
        formDataRef?.current?.values?.action,
      ) ?
        yup.mixed().test('Values', 'Values is required', (val) => {
          if (val?.length) {
            return true;
          } else {
            return false;
          }
        }) :
        null,
    fromValues:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      ['BETWEEN', 'NOT BETWEEN']?.includes(formDataRef?.current?.values?.action) ?
        yup.mixed().test('fromValues', 'From Values is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    reportpath: yup
      .mixed()
      .test('reportpath', `Invalid Folder path, Can't contain // and \\`, function(value, context) {
        const regex = /^(?!.*\\|.*\/\/).*$/;
        const {parent} = context;
        if (regex.test(parent?.reportpath)) {
          return true;
        } else {
          return false;
        }
      }),
  });
  useEffect(() => {
    dispatch(getFieldCode());
  }, []);
  const getActionsValues = (type, dropdownData) => {
    if (['amount', 'number', 'date']?.includes(type?.toLowerCase())) {
      return dropdownData?.length > 0 ? dropdownData : [];
    } else {
      const data =
        dropdownData?.length > 0 ?
          dropdownData?.filter((el) => !['BETWEEN', 'NOT BETWEEN']?.includes(el)) :
          [];
      return data;
    }
  };
  return (
    <>
      <Formik
        onSubmit={(values) => onSubmit(values)}
        initialValues={initialValue}
        validationSchema={validationSchema}
        enableReinitialize
        innerRef={formDataRef}
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleBlur,
            handleChange,
            errors,
            touched,
            resetForm,
          } = props;
          return (
            <>
              {showRuleGroupSearch ? (
                <>
                  <Button
                    variant="text"
                    className={`"mb-2" ${componentClasses.goBackBtn}`}
                    onClick={() => {
                      setShowRuleGroupSearch(false);
                    }}
                  >
                    <ArrowBack className="mr-2" />
                    Go Back
                  </Button>
                  <SearchRuleGroup />
                </>
              ) : (
                <Form autoComplete="off" noValidate>
                  <div className="global-field-textfields new-standard-textfields">
                    <div className={classes.dialoguecardStyles}>
                      {!nightJobRun && (
                        <div className=" col-md-12 form-group">
                          <BreadCrums
                            name={'Name'}
                            code={reportDialogData?.reportCode}
                            description={'Description'}
                            descriptionValue={reportDialogData?.reportDescription}
                          />
                          {/* <Typography variant="h4">
                            Report Code: {reportDialogData?.reportCode}
                          </Typography> */}
                        </div>
                      )}
                      <div className={`form-row mb-3`}>
                        {/* <div className="form-row mt-3"> */}
                        {/* <div
                          className={`col-sm-6 form-group ${classes.labelName} ${classes.selectdropdown}`}
                        >
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Run For`}
                            label="Run For"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="runFor"
                            id="runFor"
                            value={values.runFor}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </div> */}
                        {/* {accessMethodRunListData?.length > 0 && ( */}
                        <div className={`col-sm-6 col-md-4 col-xl-4 form-group`}>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="accessMethod"
                            id="accessMethod"
                            size="small"
                            value={values?.accessMethod}
                            options={fieldCodeData}
                            getOptionDisabled={(option) => option.valueCode === null}
                            getOptionLabel={(option) => {
                              return option && option?.fieldCode ? option?.description : '';
                            }}
                            required
                            onChange={(_, data) => {
                              setSubmitted(false);
                              setFieldCodeValue(data);
                              setFieldValue('accessMethod', data);
                              // setFieldValue("action", "");
                              // data?.fieldCode &&
                              //   dispatch(
                              //     postFieldCode({
                              //       fieldCode: data?.fieldCode,
                              //       options: values?.action,
                              //     })
                              //   );
                              if (['DBCLNT', 'DSSTAT', 'DBCOLLECTOR']?.includes(data.fieldCode)) {
                                setFieldValue('action', 'IN');
                                dispatch(
                                  postFieldCode({
                                    fieldCode: data.fieldCode,
                                    options: 'IN',
                                  }),
                                );
                              } else if (data.fieldCode === 'DBUDWFIELDS') {
                                setFieldValue('action', 'NOT IN');
                                dispatch(
                                  postFieldCode({
                                    fieldCode: data.fieldCode,
                                    options: 'NOT IN',
                                  }),
                                );
                              } else if (['DBLSTDTE', 'DSDISP']?.includes(data.fieldCode)) {
                                setFieldValue('action', 'Is Blank');
                                dispatch(
                                  postFieldCode({
                                    fieldCode: data.fieldCode,
                                    options: 'Is Blank',
                                  }),
                                );
                              }
                            }}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  variant="outlined"
                                  fullWidth
                                  label="Filter Method"
                                  name="accessMethod"
                                  required
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  error={Boolean(touched.accessMethod && errors.accessMethod)}
                                  placeholder="Select Filter Method"
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off',
                                  }}
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched?.accessMethod && errors?.accessMethod && errors?.accessMethod}
                          </FormHelperText>
                        </div>
                        {values?.accessMethod?.fieldCode === 'DBUDWFIELDS' && (
                          <>
                            <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3 form-group autocomplete-field">
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <GuiAutoComplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name={'repoitoryName'}
                                  size="small"
                                  onBlur={handleBlur}
                                  value={values?.repoitoryName || ''}
                                  getOptionLabel={(option) => {
                                    return option && option?.repositoryName ? option?.repositoryName : '';
                                  }}
                                  onChange={(e, value) => {
                                    resetPromptDataRef.current = true;
                                    setFieldValue('repoitoryName', value);
                                    setFieldValue('fieldsName', '');
                                    setFieldValue('action', ' NOT IN');
                                    if (values?.accessMethod?.fieldCode) {
                                      dispatch(
                                        postFieldCode({
                                          fieldCode: values?.accessMethod?.fieldCode,
                                          options: 'NOT IN',
                                        }),
                                      );
                                    }
                                    value?.repositoryName ?
                                      dispatch(fetchUserDefinedFields(value?.repositoryName)) :
                                      null;
                                  }}
                                  options={userDefinedWindowData}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        className={` ${classes.labelName}`}
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        label={'Repository Name'}
                                        required
                                        error={Boolean(
                                          touched?.repoitoryName && errors?.repoitoryName,
                                        )}
                                        placeholder={'Repository Name'}
                                      />
                                    </div>
                                  )}
                                />
                              </FormControl>
                              <FormHelperText style={{color: 'red'}} variant="outlined">
                                {touched?.repoitoryName &&
                                  errors?.repoitoryName &&
                                  errors?.repoitoryName}
                              </FormHelperText>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3 form-group autocomplete-field">
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <GuiAutoComplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name={'fieldsName'}
                                  size="small"
                                  onBlur={handleBlur}
                                  value={values?.fieldsName || ''}
                                  onChange={(e, value) => {
                                    resetPromptDataRef.current = true;
                                    setFieldValue('action', 'NOT IN');
                                    if (values?.accessMethod?.fieldCode) {
                                      dispatch(
                                        postFieldCode({
                                          fieldCode: values?.accessMethod?.fieldCode,
                                          options: 'NOT IN',
                                        }),
                                      );
                                    }
                                    setFieldValue('fieldsName', value);
                                  }}
                                  options={userDefinedFieldsData}
                                  getOptionLabel={(option) => {
                                    return option && option?.fieldName ? option.fieldName : '';
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        className={` ${classes.labelName}`}
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        required
                                        error={Boolean(touched?.fieldsName && errors?.fieldsName)}
                                        label={'Field Name'}
                                        placeholder={'Enter Field Name'}
                                      />
                                    </div>
                                  )}
                                />
                              </FormControl>
                              <FormHelperText style={{color: 'red'}} variant="outlined">
                                {touched?.fieldsName && errors?.fieldsName && errors?.fieldsName}
                              </FormHelperText>
                            </div>
                          </>
                        )}
                        {values?.accessMethod?.fieldCode !== 'DBACCT' && (
                          <>
                            <div className="col-sm-6 col-md-4 col-lg-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="action"
                                id="action"
                                size="small"
                                value={values?.action}
                                options={
                                  values?.accessMethod?.fieldCode === 'DBUDWFIELDS' ?
                                    getActionsValues(values?.fieldsName?.fieldType, actionData) :
                                    actionData
                                }
                                disabled={fieldCodeValue?.fieldCode === 'DBACCT'}
                                getOptionLabel={(option) => {
                                  return option ? option : '';
                                }}
                                required
                                onChange={(_, data) => {
                                  setFieldValue('action', data);
                                  resetPromptDataRef.current = true;
                                  values?.accessMethod?.fieldCode &&
                                    data &&
                                    dispatch(
                                      postFieldCode({
                                        fieldCode: values?.accessMethod?.fieldCode,
                                        options: data,
                                      }),
                                    );
                                }}
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      margin="dense"
                                      className={` ${classes.labelName}`}
                                      {...params}
                                      variant="outlined"
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      fullWidth
                                      label="Action"
                                      name="action"
                                      placeholder="Select Action"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'off',
                                      }}
                                    />
                                  </div>
                                )}
                              />
                            </div>
                            {values?.action && (
                              <div
                                className={`${
                                  values?.accessMethod?.fieldCode === 'DBUDWFIELDS' ?
                                    'col-lg-6' :
                                    'col-lg-4'
                                } ${componentClasses.conditionalFields}`}
                              >
                                <div className="form-row">
                                  <GetAccessMethodFields
                                    values={values}
                                    formProps={props}
                                    reportDialogData={reportDialogData}
                                    setFieldValue={setFieldValue}
                                    accessMethodFields={promptData}
                                    setShowRuleGroupSearch={setShowRuleGroupSearch}
                                    fieldCodeValue={fieldCodeValue}
                                    additionalInfoData={data?.accessMethodInfo}
                                    renderedFrom={'Run Report'}
                                    fieldSubmitted={fieldSubmitted}
                                    setSubmitted={setSubmitted}
                                  />
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        {/* // added fields */}
                        <div className={`col-sm-6 col-md-4 col-lg-4 form-group `}>
                          <TextField
                            className={` ${classes.labelName}`}
                            placeholder="Enter Notify Completion Emails"
                            margin="dense"
                            name="notifyCompletion"
                            variant="outlined"
                            value={values?.notifyCompletion}
                            label="Notify Completion Emails"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            // required
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setFieldValue('notifyCompletion', e.target.value);
                              // if (e.target.value) {
                              //   setCodePopover(true);
                              //   setReportCodesData(e.target.value);
                              // } else if (e.target.value === "") {
                              //   setCodePopover(false);
                              // }
                            }}
                            // touched={touched.notifyCompletion}
                            // error={Boolean(errors.notifyCompletion && touched.notifyCompletion)}
                            fullWidth
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched.notifyCompletion && errors.notifyCompletion}
                          </FormHelperText>
                        </div>
                        <div className={`col-sm-6 col-md-4 col-xl-4 form-group`}>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="displayHeader"
                            id="displayHeader"
                            size="small"
                            value={values?.displayHeader}
                            autoHighlight
                            options={displayHeaderData}
                            getOptionLabel={(option) => {
                              return option && option?.value ? option?.value : '';
                            }}
                            onChange={(_, data) => {
                              setFieldValue('displayHeader', data);
                            }}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  {...params}
                                  variant="outlined"
                                  fullWidth
                                  label="Display Header"
                                  name="displayHeader"
                                  error={Boolean(touched.displayHeader && errors.displayHeader)}
                                  required
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off',
                                  }}
                                  placeholder="Select Display Header"
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched.displayHeader && errors.displayHeader && errors.displayHeader}
                          </FormHelperText>
                        </div>
                        <div className={`col-sm-6 col-md-4 col-xl-4 form-group`}>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            id="reportFormat"
                            name="reportFormat"
                            size="small"
                            autoHighlight
                            value={values?.reportFormat}
                            options={
                              // fixedLength1 === "Y"
                              //   ? getOptions(FILE_TYPE, dropDownDataReportFormat)?.filter(
                              //       (each) => each?.value === "Text"
                              //     )
                              getOptions(FILE_TYPE, dropDownDataReportFormat)
                            }
                            getOptionDisabled={(option) => option?.valueCode === 'none'}
                            getOptionLabel={(option) => {
                              return option && option?.value ?
                                option?.valueCode === null ?
                                  option?.value :
                                  option?.valueCode + ' - ' + option?.value :
                                '';
                            }}
                            onChange={(_, data) => {
                              setFieldValue('reportFormat', data);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <TextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  {...params}
                                  variant="outlined"
                                  fullWidth
                                  label="Report Output Format"
                                  name="reportFormat"
                                  required
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  error={Boolean(touched.reportFormat && errors.reportFormat)}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off',
                                  }}
                                  placeholder="Select Report Output Format"
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched.reportFormat && errors.reportFormat && errors.reportFormat}
                          </FormHelperText>
                        </div>

                        {/* {initialValues?.fixedLength !== "Y" && fixedlength === "N" && ( */}
                        {/* {reportDialogData?.fixedLength === "N" &&
                          values?.reportFormat?.value !== "Excel" && ( */}
                        <div className={`col-sm-6 col-md-4 col-xl-4 form-group`}>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            id="fieldSeparator"
                            name="fieldSeparator"
                            size="small"
                            value={values?.fieldSeparator}
                            autoHighlight
                            options={getOptionsRecordFormatDropDown(
                              FIELD_SEPERATOR,
                              dropDownDataReportFormat,
                            )}
                            getOptionLabel={(option) => {
                              return option && option?.value ? option?.value : '';
                            }}
                            renderOption={(option) => {
                              return option?.value ?
                                option?.value + '  ' + `(${option?.valueCode})` :
                                '';
                            }}
                            onChange={(_, data) => {
                              setFieldValue('fieldSeparator', data);
                            }}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  variant="outlined"
                                  fullWidth
                                  required={reportDialogData?.fixedLength === 'N'}
                                  error={Boolean(touched.fieldSeparator && errors.fieldSeparator)}
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off',
                                  }}
                                  label="Field Separator"
                                  name="fieldSeparator"
                                  placeholder="Select Field Separator"
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched.fieldSeparator &&
                              errors.fieldSeparator &&
                              errors.fieldSeparator}
                          </FormHelperText>
                        </div>
                        {/* )} */}
                        {/*  )} */}

                        <div className={`col-sm-6 col-md-4 col-lg-4 form-group `}>
                          <TextField
                            className={` ${classes.labelName}`}
                            placeholder="Enter Notify Error Emails"
                            margin="dense"
                            name="notifyError"
                            variant="outlined"
                            value={values?.notifyError}
                            label="Notify Error Emails"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            // required
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setFieldValue('notifyError', e.target.value);
                            }}
                            fullWidth
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched.notifyError && errors.notifyError}
                          </FormHelperText>
                        </div>

                        <div
                          className={`col-sm-6 col-md-4 col-xl-4 form-group py-1 reportout-filed`}
                        >
                          <TextField
                            className={` ${classes.labelName}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Report Folder Path`}
                            label={'Report Folder Path'}
                            multiline
                            rows={2}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  style={{cursor: 'pointer'}}
                                  onClick={() => setFolderPath(true)}
                                  position="start"
                                >
                                  <AddBoxOutlinedIcon />
                                </InputAdornment>
                              ),
                            }}
                            name={'reportpath'}
                            value={values?.reportpath}
                            onChange={(e) => {
                              setFieldValue('reportpath', e.target.value);
                            }}
                            fullWidth
                            touched={touched.reportpath}
                            error={touched.reportpath && errors.reportpath}
                          />
                          <FormHelperText
                            style={{color: 'red', paddingTop: '5px'}}
                            variant="outlined"
                          >
                            {touched.reportpath && errors.reportpath && errors.reportpath}
                            {''}
                          </FormHelperText>
                        </div>
                        <div
                          className={`col-sm-6 col-md-4 col-xl-4 form-group py-1 reportout-filed`}
                        >
                          <TextField
                            className={` ${classes.labelName}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Report Output File Name`}
                            label={'Report Output File Name'}
                            multiline
                            rows={2}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  style={{cursor: 'pointer'}}
                                  onClick={() => setOpen(true)}
                                  position="start"
                                >
                                  <AddBoxOutlinedIcon />
                                </InputAdornment>
                              ),
                            }}
                            name={'outputFileName'}
                            value={values?.outputFileName}
                            onChange={(e) => {
                              setFieldValue('outputFileName', e.target.value);
                            }}
                            fullWidth
                            touched={touched.outputFileName}
                          />
                        </div>

                        <DialogBox
                          open={open}
                          dialogClose={handleClose}
                          hideFooter={true}
                          maxWidth={'xl'}
                          title={'Report File Name'}
                        >
                          <AddFileName
                            setFieldValues={setFieldValue}
                            setOpen={setOpen}
                            addValues={values}
                            handleClose={handleClose}
                          />
                        </DialogBox>
                        <DialogBox
                          open={folderPath}
                          dialogClose={handleClose}
                          hideFooter={true}
                          maxWidth={'xl'}
                          title={'Report Folder Path'}
                        >
                          <ReportFolderPath
                            setFieldValues={setFieldValue}
                            setOpen={setOpen}
                            addValues={values}
                            handleClose={handleClose}
                            folderPath={folderPath}
                          />
                        </DialogBox>
                      </div>
                      {!nightJobRun && (
                        <div className="row justify-content-center">
                          <Button
                            variant="outlined"
                            className={`reset-btn mr-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              resetForm(initialValue);
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="outlined"
                            type="submit"
                            className={`search-btn ml-1 ${classes.buttonRoot} `}
                            disabled={!reportRoleAccess?.edit}
                            onClick={() => {
                              setSubmitted(true);
                              if (formDataRef.current.isValid) {
                                setSubmitted(false);
                              }
                            }}
                          >
                            Run
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </Form>
              )}
            </>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
    </>
  );
};

export default RunaReportMaster;
